import styles from './ListItem.module.scss';

import * as React from 'react';

import { css } from '../../../util/Css';
import { Icon } from '@fluentui/react';

export interface ListItemProps {
  title: string;
  value?: string;
  value2?: string;
  value3?: JSX.Element | string;
  iconName?: string;
  active: boolean;
  enabled: boolean;
  completed: boolean;
  testId?: string;
  onClick: () => void;
}

export class ListItem extends React.Component<ListItemProps> {
  public render(): JSX.Element {
    const containerStyles = css(styles.listItem, {
      [styles.active]: this.props.active,
      [styles.completed]: this.props.completed,
      [styles.disabled]: !this.props.enabled,
    });

    return (
      <table cellSpacing="0" className={containerStyles} onClick={this.onClick} data-tid={this.props.testId}>
        <tbody>
          <tr>
            <td className={styles.imageContainer}>
              <Icon className={styles.image} iconName={this.props.iconName} />
            </td>
            <td className={styles.textContainer}>
              <div className={styles.title}>{this.props.title}</div>
              {this.renderValue(this.props.value)}
              {this.renderValue(this.props.value2)}
              {this.renderValue(this.props.value3, typeof this.props.value3 === 'string')}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  private onClick = (e: React.MouseEvent<HTMLElement>) => {
    if (!this.props.enabled) {
      e.preventDefault();
      return;
    }
    this.props.onClick();
  };

  private renderValue(value?: string | JSX.Element, truncate = false): JSX.Element | null {
    if (value) {
      return (
        <div className={css(styles.value, { [styles.truncated]: truncate })}>
          <span>{value}</span>
        </div>
      );
    }
    return null;
  }
}
